import { ListAgenticLogicPlacementAssignmentsResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { agenticLogicKeys } from "../queryKeys";

const listAgenticLogicAssignments = async () => {
  const resp =
    await api.get<ListAgenticLogicPlacementAssignmentsResponseBodyType>(
      `/v2/agentic-logic/assignments`
    );
  return resp.data;
};

export const useAgenticLogicAssignments = () => {
  return useQuery<ListAgenticLogicPlacementAssignmentsResponseBodyType, Error>({
    queryKey: agenticLogicKeys.assignments(),
    queryFn: async () => listAgenticLogicAssignments(),
  });
};
